import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import Editor from '../../components/editor'


const Notice = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [notice, setNotice] = useState();
    const [content, setContent] = useState('')
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/notices/${params.id}`)
            const payload = response.data;

            setNotice(payload.data)
        }

        fetchData().catch(e => console.error(e));
    }, [params.id])

    useEffect(() => {
        const defaultValues = {
            title: notice?.title
        }
        reset(defaultValues)

        setContent(notice?.descript)

    }, [reset, notice])

    const goBack = () => {
        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        await apiService.put(`/notices/${notice.nid}`, {
            "title": data.title,
            "descript": content
        }).then(response => {
            toast.success('수정 되었습니다')
            goBack()
        }).catch(error => {
            console.error(error)
        })
    }

    return (
        <Page title="Notice">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="noticeform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                공지
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='제목'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                aria-describedby='validation-async-title'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                    {errors.title && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Editor content={content} setContent={setContent} />
                            </Grid>

                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="noticeform" variant='contained'> 수정 </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}> 취소 </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Notice